<template>
    <modal :saveAction="save" :deleteAction="data._id ? deleteAction : false" :title="$t(title)" :id="id" :actionButtons="true" size="md" scrollable @shown="shown" @hidden="hidden">
        <div class="row align-items-top">
            <div class="col-12">
                <div class="form-group">
                    <label>{{$t("Name")}}</label>
                    <b-form-input v-model="data.label"></b-form-input>
                </div>
            </div>
            <div class="col-12">
                <b-form-group :label="$t('Color')" class="mb-0"></b-form-group>
                <div class="row align-items-center">
                    <div
                        class="pointer col-1 mr-1 mb-1 p-2 text-center border rounded rounded-3"
                        :style="'background-color:' + color"
                        v-for="color in colors"
                        @click="$set(data, 'color', color)"
                        :key="color"
                    >
                        <i class="fe fe-check text-white p-0 m-0" v-if="color === data.color"></i>
                        <span v-else>&nbsp;</span>
                    </div>
                </div>
            </div>
        </div>
    </modal>
</template>

<script>
    import Modal from "@/components/Modal.vue";
    import {mapActions} from 'vuex';

    export default {
        name: 'WorkPlaceModal',
        props: ['id', 'model'],
        components: {
            Modal
        },
        computed: {},
        data() {
            return {
                title: 'Workplace',
                colors: [
                    '#FF9CBB',
                    '#E2A6E6',
                    '#BBC1E8',
                    '#A5DFF8',
                    '#4baea0',
                    '#b6e6bd',
                    '#f1f0cf',
                    '#f0c9c9',
                    '#003f5c',
                    '#58508d',
                    '#bc5090',
                ],
                data: {}
            }
        },
        created() {
        },
        methods: {
            ...mapActions('work-place', ['create', 'patch', 'remove']),
            close() {
                this.$root.$emit('bv::hide::modal', this.id);
            },

            deleteAction() {
                this.remove(this.data._id).then(result => {
                    this.$toasted.global.success({
                        message: this.$t('Workplace has been removed')
                    });
                });
            },

            shown() {
                const {WorkPlace} = this.$FeathersVuex;
                let data = WorkPlace.getFromStore('temp');
                if (data) {
                    delete data._id;
                    this.data = this.$copy(data.model);
                    new WorkPlace({
                        _id: 'temp',
                        model: {}
                    });
                }
            },

            save() {
                let promise;
                if (this.data._id) {
                    promise = this.patch([this.data._id, this.data])
                } else {
                    promise = this.create(this.data);
                }
                promise.then(() => {
                    this.close();
                    this.$toasted.global.success({
                        message: this.$t('Workplace has been saved')
                    });
                })
            },

            hidden() {
                this.data = {};
            }
        },

    }
</script>
